import { useState, useEffect } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import { Typography } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import { PickerBase } from './picker-base'
import { t } from '@lingui/core/macro'

export const PatternPicker = props => {
  const [selected, setSelected] = useState({})
  const [displayPatterns, setDisplayPatterns] = useState(props.patterns)

  useEffect(() => {
    setDisplayPatterns(props.patterns)
  }, [props.patterns])

  useEffect(() => {
    setSelected({})
  }, [props.selected])

  function search(e) {
    setDisplayPatterns(
      props.patterns.filter(pat => pat.name.toLowerCase().includes(e.target.value.toLowerCase())),
    )
  }

  function handleChange(id) {
    const newSelected = { ...selected }
    if (newSelected[id]) {
      delete newSelected[id]
    } else {
      newSelected[id] = true
    }
    setSelected(newSelected)
  }

  return (
    <PickerBase {...props}>
      <AppBar
        position="relative"
        style={{
          padding: '0 24px',
          flex: 1,
          height: 60,
          maxHeight: 60,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
        }}
      >
        <div style={{ flex: 1 }}>{t`Select patterns`}</div>
        <div style={{ flex: 1, justifyContent: 'flex-end', textAlign: 'right' }}>
          <TextField
            placeholder={t`Search`}
            variant="outlined"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.12',
              color: 'white',
              borderRadius: 4,
              margin: 0,
            }}
            onChange={search}
            margin="dense"
            inputProps={{
              style: { color: 'white !important' },
            }}
            InputProps={{
              style: { color: 'white' },
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </AppBar>
      <div style={{ flex: 1, overflow: 'scroll', padding: '0 24px' }}>
        {displayPatterns.map(pat => (
          <div key={pat.id}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selected[pat.id] || props.selected[pat.id]}
                  disabled={Boolean(props.selected[pat.id])}
                  onChange={() => {
                    handleChange(pat.id)
                  }}
                  value={pat.id}
                />
              }
              label={pat.name}
            />
          </div>
        ))}
        {!displayPatterns.length ? (
          <Typography variant="subtitle2" style={{ textAlign: 'center', marginTop: 24 }}>
            {t`No matching patterns`}
          </Typography>
        ) : null}
      </div>
      <div
        style={{
          flex: 1,
          padding: '0 24px',
          height: 60,
          maxHeight: 60,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          borderTop: '1px solid #DDE1E3',
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            props.onApplySelection(Object.keys(selected))
          }}
          style={{ padding: '6px 28px' }}
        >
          {t`Select patterns`}
        </Button>
      </div>
    </PickerBase>
  )
}
